import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ZentaraLogo } from "@/components/Logo";
import { LayoutDashboard, Users, LogOut, FileText } from "lucide-react";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/dashboard", label: "Projects", icon: LayoutDashboard, testid: "nav-jobs" },
  { to: "/reports", label: "Reports", icon: FileText, testid: "nav-reports" },
  { to: "/team", label: "Team", icon: Users, testid: "nav-team" },
];

export function Layout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background grid-bg">
      <aside className="fixed inset-y-0 left-0 z-30 flex w-64 flex-col border-r border-white/10 bg-[#141414]/90 backdrop-blur-xl">
        <div className="border-b border-white/10 px-5 py-5">
          <ZentaraLogo markSize={44} />
        </div>

        <nav className="flex-1 space-y-1 px-3 py-5">
          {NAV.map((item) => {
            const active = location.pathname.startsWith(item.to);
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testid}
                className={cn(
                  "flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold transition-colors",
                  active
                    ? "bg-[#c5a24a]/15 text-[#c5a24a]"
                    : "text-neutral-400 hover:bg-white/5 hover:text-neutral-100"
                )}
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="border-t border-white/10 p-3">
          <div className="mb-2 px-2">
            <div className="truncate text-sm font-semibold text-[#f7f3ec]" data-testid="current-user-name">
              {user?.name}
            </div>
            <div className="truncate text-xs text-neutral-500">{user?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="flex w-full items-center gap-2 rounded-lg px-2 py-2 text-sm text-neutral-400 transition-colors hover:bg-white/5 hover:text-neutral-100"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="ml-64 min-h-screen">{children}</main>
    </div>
  );
}
